import { defineStore } from "pinia";
import { computed, ref } from "vue";

// api
import { uiFeaturesApi } from "@/api/uiFeatures";

// interfaces
import type { UiFeatures } from "@/interfaces/UiFeatures";

export const useUiFeatures = defineStore("ui-features", () => {
  const getUiFeaturesInitialData = (): UiFeatures => ({
    jobOfferAttributeItems: false,
    jobOfferTemplates: false,
  });

  const uiFeatures = ref<UiFeatures>(getUiFeaturesInitialData());
  const isLoading = ref(false);
  const isFetched = ref(false);

  const jobOfferAttributeItems = computed(
    () => uiFeatures.value.jobOfferAttributeItems,
  );

  const fetchUiFeatures = async ({ companyId }: { companyId: string }) => {
    try {
      isLoading.value = true;

      uiFeatures.value = await uiFeaturesApi().getUiFeatures({ companyId });

      isFetched.value = true;
    } catch (error) {
      console.error(error);
    } finally {
      isLoading.value = false;
    }
  };

  return {
    uiFeatures,
    isLoading,
    isFetched,
    jobOfferAttributeItems,
    fetchUiFeatures,
  };
});
